/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { useDispatch } from 'react-redux';
import './message.scss';
import { getUniqueId } from '../../widget/util/commonUtil';
import { hasUserInteractedWithBot } from '../../actions/index';

type messageLinkProps = {
    text: string,
    link: string,
    callBackFn: () => void
}

const MessageLiveChatQR = ({text, link, callBackFn}: messageLinkProps) => {
    const dispatch = useDispatch();
    
    const handleOnClick = () => {
        dispatch(hasUserInteractedWithBot(true));
        callBackFn();
    }

    return (
        <div className="message__text--quick-reply">           
            <a href={link} onClick={handleOnClick} className="message__link" id={getUniqueId('message-link', text)} target="_blank" rel="noreferrer">{text}</a>           
        </div>
    )
}

export default MessageLiveChatQR
